// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","container":"_37L2MUD25AxMObTKX9ld4K","title":"_3HUETwTgofRlLb-5hUgNxs","text":"_1wZHWNb0iIzYYh0KcDzXOx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Lecture/Lecture.mod.css
// module id = 1564
// module chunks = 0